var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.showModal}},[_vm._v(_vm._s(_vm.t('my_subscription.modal.show')))])])}
var staticRenderFns = []

export { render, staticRenderFns }